// Define application wide routes
const ROUTE_PATH = {
  LOGIN: '/login',
  DASHBOARD: '/',
  CONTENT_CHANNELS: '/content/channels',
  CONTENT_CATEGORIES: '/content/categories',
  CATEGORY_VIDEOS: '/content/categories/:id/manage-content',
  CATEGORY_VIDEOS_ORDER: '/content/categories/:id/manage-content/content-order',
  CONTENT_COLLECTIONS: '/content/collections',
  CONTENT_COLLECTIONS_MANAGE_CATEGORIES:
    '/content/collections/:id/manage-categories',
  CONTENT_COLLECTION_MANAGE_CATEGORY_ORDER:
    '/content/collection/:id/manage-categories/manage-category-order',
  CONTENT_VIDEOS: '/content/videos',
  CONTENT_SEQUENCE: '/content/sequence',
  CONTENT_SEQUENCE_CATEGORY: '/categories',
  CONTENT_SEQUENCE_PLAYLIST: '/playlist',
  CONTENT_TABS: '/content/tabs',
  REPORTS_OVERVIEW_VIDEOS: '/reports/overview/videos',
  REPORTS_WATCH_SESSIONS: '/reports/watch/sessions',
  REPORTS_APP_SESSIONS: '/reports/app/sessions',
  ADMIN_USERS: '/users',
  LOGOUT: '/logout',
};

export default ROUTE_PATH;
